import { FaHospital, FaPiggyBank, FaShoppingCart, FaCogs, FaChalkboardTeacher, FaStethoscope, FaAmbulance, FaHeart, FaShieldAlt, FaChartLine, FaShieldVirus, FaUserTie, FaWallet, FaChartBar, FaLock, FaBolt, FaTools, FaSolarPanel, FaLeaf } from 'react-icons/fa';
import { FaCartShopping, FaTruckFast } from 'react-icons/fa6';

const industries = [
    {
        id: 'healthcare',
        icon: <FaHospital />,
        title: 'Healthcare',
        heading: 'Transforming Healthcare with AI Solutions',
        description: [
        'We leverage cutting-edge AI technologies to enhance healthcare services and optimize medical operations. Our solutions empower healthcare professionals with data-driven insights and more efficient care.',
        'From predictive analytics for patient care to AI-driven diagnostic tools, we help healthcare providers streamline their processes and deliver high-quality services. Our innovations are designed to improve the patient experience.',
        ],
        features: [
        { icon: <FaStethoscope />, text: 'AI diagnostic tools for early disease detection.' },
        { icon: <FaAmbulance />, text: 'Predictive analytics to optimize patient care.' },
        { icon: <FaHeart />, text: 'Remote health monitoring for better accessibility.' },
        { icon: <FaShieldAlt />, text: 'Robust data security to protect patient information.' },
        ],
    },
    {
        id: 'finance',
        icon: <FaPiggyBank />,
        title: 'Finance',
        heading: 'Revolutionizing Finance with AI Solutions',
        description: [
        'We harness the power of AI to transform the financial industry, delivering smarter decision-making, enhanced security, and optimized processes. Our innovative solutions empower financial institutions with actionable insights and automation.',
        'From fraud detection to personalized customer experiences, we enable businesses to streamline their operations, mitigate risks, and improve profitability. Our tools are designed to bring efficiency and transparency to the financial ecosystem.',
        ],
        features: [
        { icon: <FaChartLine />, text: 'AI-driven financial analytics for decision-making.' },
        { icon: <FaShieldVirus />, text: 'Advanced fraud detection and risk mitigation solutions.' },
        { icon: <FaUserTie />, text: 'Personalized financial advisory services powered by AI.' },
        { icon: <FaWallet />, text: 'Streamlined digital payments and secure transactions.' },
        ],
    },
    {
        id: 'ecommerce',
        icon: <FaShoppingCart />,
        title: 'E-commerce',
        heading: 'Empowering E-Commerce with AI Solutions',
        description: [
        'We leverage AI technologies to redefine the e-commerce landscape, enabling businesses to enhance customer experiences, optimize operations, and drive growth. Our solutions bring efficiency and personalization to online retail.',
        'From intelligent product recommendations to automated inventory management, we provide tools to streamline processes and improve sales performance. Our innovations are designed to meet the evolving needs of modern e-commerce businesses.',
        ],
        features: [
        { icon: <FaCartShopping />, text: 'AI product recommendations to boost engagement.' },
        { icon: <FaTruckFast />, text: 'Smart inventory management for efficiency.' },
        { icon: <FaChartBar />, text: 'Predictive analytics for better demand sales strategies.' },
        { icon: <FaLock />, text: 'Enhanced payment security and fraud prevention systems.' },
        ],
    },
    {
        id: 'manufacturing',
        icon: <FaCogs />,
        title: 'Manufacturing',
        heading: 'Revolutionizing Manufacturing with AI Solutions',
        description: [
        'We leverage cutting-edge AI technologies to transform the manufacturing industry, enhance operational efficiency, and optimize production processes. Our solutions empower manufacturers with intelligent tools to boost productivity.',
        'From predictive maintenance to quality control, we help manufacturing businesses stay competitive in a dynamic market. Our innovations are designed to increase efficiency and reduce costs.',
        ],
        features: [
        { icon: <FaCartShopping />, text: 'AI product recommendations for personalized shopping.' },
        { icon: <FaTruckFast />, text: 'Intelligent inventory management to reduce waste.' },
        { icon: <FaChartBar />, text: 'Predictive analytics for forecasting demand.' },
        { icon: <FaLock />, text: 'Secure payment solutions for safe transactions.' },
        ],
    },
    {
        id: 'energy',
        icon: <FaChalkboardTeacher />,
        title: 'Energy',
        heading: 'Driving Innovation in Energy with AI Solutions',
        description: [
        'We utilize advanced AI technologies to revolutionize the energy sector, enhancing efficiency, sustainability, and resource management. Our solutions empower energy companies to optimize operations, reduce costs, and embrace greener practices.',
        'From smart grid management to predictive maintenance, we help energy providers adopt innovative tools for improved decision-making and operational excellence. Our AI-driven systems ensure a reliable energy supply while supporting a transition to renewable resources.',
        ],
        features: [
        { icon: <FaBolt />, text: 'Smart grid solutions for efficient energy management.' },
        { icon: <FaTools />, text: 'Predictive maintenance to improve asset lifespan.' },
        { icon: <FaSolarPanel />, text: 'AI analytics for optimizing renewable energy usage.' },
        { icon: <FaLeaf />, text: 'Support for sustainable carbon footprint reduction.' },
        ],
    },
];

export default industries;